import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OperationResult } from '../../../models/chat.model';
import { ChatItem } from '../../../models/chat-ui.model';
import { ChatService } from '../api/chat.service';
import { FrontendLoggerService } from '../../frontend-logger.service';
import { ChatDomEffectsService } from './chat-dom-effects.service';
import { ChatMessageTextService } from './chat-message-text.service';

export interface ChatFeedbackPanelState {
  feedbackTargetIndex: number | null;
  feedbackLike: boolean | null;
  feedbackSent: boolean;
  feedbackRating: number;
  hoverRating: number;
  feedbackComment: string;
}

@Injectable({
  providedIn: 'root'
})
export class ChatFeedbackUiService {
  constructor(
    private chatService: ChatService,
    private messageText: ChatMessageTextService,
    private chatDomEffects: ChatDomEffectsService,
    private frontendLogger: FrontendLoggerService
  ) {}

  getStarClass(star: number, hoverRating: number, feedbackRating: number): string {
    const value = hoverRating || feedbackRating;
    if (value >= star) {
      return 'fas fa-star';
    }

    return value >= star - 0.5 ? 'fas fa-star-half-alt' : 'far fa-star';
  }

  getStarColor(star: number, hoverRating: number, feedbackRating: number): string {
    const value = hoverRating || feedbackRating;
    return value >= star - 0.5 ? '#FFD700' : '#ccc';
  }

  buildToggleState(currentTargetIndex: number | null, index: number, like: boolean): ChatFeedbackPanelState {
    if (currentTargetIndex === index) {
      return this.buildClosedState();
    }

    this.chatDomEffects.scrollElementByIdDeferred(`chat-message-${index}`, 60);
    return {
      feedbackTargetIndex: index,
      feedbackLike: like,
      feedbackSent: false,
      feedbackRating: 0,
      hoverRating: 0,
      feedbackComment: ''
    };
  }

  buildClosedState(): ChatFeedbackPanelState {
    return {
      feedbackTargetIndex: null,
      feedbackLike: null,
      feedbackSent: false,
      feedbackRating: 0,
      hoverRating: 0,
      feedbackComment: ''
    };
  }

  buildSentState(): ChatFeedbackPanelState {
    return {
      feedbackTargetIndex: null,
      feedbackLike: null,
      feedbackSent: true,
      feedbackRating: 0,
      hoverRating: 0,
      feedbackComment: ''
    };
  }

  copyMessageToClipboard(message: Pick<ChatItem, 'content'>): Promise<void> {
    const text = this.messageText.normalize(message.content || '');
    return this.chatDomEffects.copyText(text);
  }

  saveFeedback(liked: boolean | null, comment: string, rating: number): Observable<OperationResult> {
    const likedBool = !!liked;
    this.frontendLogger.info(
      `Enviando feedback: ${likedBool ? 'like' : 'dislike'}, rating: ${rating}`,
      'ChatFeedbackUiService.saveFeedback'
    );
    return this.chatService.saveFeedback(likedBool, comment, rating);
  }
}
